var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1882_20971)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4423 18.6491L8.33952 18.5766C7.01068 18.5514 5.67885 18.6017 4.37709 18.3408C2.39538 17.9503 2.25498 16.0377 2.10855 14.4334C1.90597 12.1776 1.98419 9.88132 2.3663 7.64492C2.58192 6.38949 3.43036 5.64145 4.74215 5.5593C9.17192 5.26356 13.6308 5.29835 18.0505 5.43656C18.5169 5.44912 18.9872 5.51871 19.4475 5.59699C21.7191 5.98067 21.7752 8.14845 21.9227 9.97313C22.0691 11.8162 22.0079 13.6689 21.7271 15.5003C21.5015 17.0157 21.0712 18.2876 19.252 18.4103C16.9734 18.5708 14.747 18.7003 12.4624 18.6587C12.4624 18.6491 12.4484 18.6491 12.4423 18.6491ZM10.0304 14.8112C11.7473 13.8612 13.4322 12.9266 15.1391 11.9834C13.4192 11.0333 11.7373 10.0988 10.0304 9.1555V14.8112Z",
    fill: "#1271A6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1882_20971"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.9996,
    height: 19.9996,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/Youtube.38b9e6a230349a8f63976d8e877e071b.svg";
export { ForwardRef as ReactComponent };